import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_ROADIE_API_URL,
})

const DEFAULTS = api.defaults
const HEADERS = DEFAULTS.headers || {}

export function setSessionToken(token) {
  Object.assign(DEFAULTS, {
    headers: {
      ...HEADERS,
      'Session-Token': token,
    }
  })
}

export function clearSessionToken() {
  Object.assign(DEFAULTS, {
    headers: HEADERS
  })
}

api.version = version => axios.create({
  ...api.defaults,
  headers: {
    ...api.defaults.headers,
    Accept: `application/json, text/plain, */*; version=${version}`
  }
})

export default api
